import { Component, Input, OnInit } from "@angular/core";
import { StateService, UIRouterGlobals } from "@uirouter/core";
import { finalize, map } from "rxjs/operators";
import { ErrorRateListService } from "../../error-rate-list/error-rate-list.service";
import { RoutesStatsService } from "../../models/routes-stats.service";
import { RoundTimeService } from "../../round-time/round-time.service";
import { TimeDurAgoService } from "../../time-dur-ago/time-dur-ago.service";

@Component({
  selector: "ab-route-view",
  templateUrl: "./route-view.component.html",
})
export class RouteViewComponent implements OnInit {
  @Input() public project: any;

  public getexceptional: any;
  public dur: any;
  public lastN: any;
  public route: any;
  public statusCode: any;
  public timeDurSwitchEnabled: boolean;
  public loadingRouteStats: boolean;
  public routeStats: any;
  public timeDurAgo: string;
  public errorRateList: number[];

  constructor(
    private $state: StateService,
    private $uiRouterGlobals: UIRouterGlobals,
    private errorRateListService: ErrorRateListService,
    private roundTimeService: RoundTimeService,
    private routesStatsService: RoutesStatsService,
    private timeDurAgoService: TimeDurAgoService,
  ) {}

  public ngOnInit() {
    this.dur = this.$uiRouterGlobals.params.dur || "90d/1d";
    this.lastN = this.$uiRouterGlobals.params.last_n || 90;

    this.route = {
      routeId: this.$uiRouterGlobals.params.routeId,
      status: this.$uiRouterGlobals.params.status,
      projectId: this.project.id,
      dur: this.dur,
      lastN: this.lastN,
    };
    this.timeDurAgo = this.timeDurAgoService.timeFor(this.dur, this.lastN);

    this.setRouteStats().subscribe();
  }

  public uiOnParamsChanged(newParams: { [paramName: string]: any }) {
    if (newParams.status) {
      this.route.status = newParams.status;
      this.statusCode = this.findStatusCode(this.routeStats, newParams.status);
    }
  }

  public onTimeDurSwitchChange(params: any) {
    this.dur = params.dur;
    this.lastN = params.last_n;
    this.timeDurAgo = this.timeDurAgoService.timeFor(this.dur, this.lastN);
    this.setRouteStats().subscribe((statusCode: any) => {
      if (!statusCode) {
        return;
      }

      const status = statusCode.value || statusCode.name;
      this.route.status = status;
      this.$state.go(this.$uiRouterGlobals.current.name, {
        status,
        reload: false,
      });
    });
  }

  private setRouteStats() {
    const period = (() => {
      switch (this.dur.split("/")[1]) {
        case "1d":
          return "day";
        case "1h":
          return "hour";
        case "1m":
          return "minute";
      }
    })();

    const params = {
      projectId: this.route.projectId,
      routeId: this.route.routeId,
      period,
      time__gte: this.roundTimeService.timestampFor(this.timeDurAgo, this.dur),
      with_status_codes: true,
    } as any;

    if (this.project.apdexThreshold > 0) {
      // Apdex Threshold in ms.
      params.t = this.project.apdexThreshold * 1000;
    }

    this.timeDurSwitchEnabled = false;
    this.loadingRouteStats = true;
    return this.routesStatsService
      .get(params)
      .pipe(
        map((data: any) => {
          this.route.route = data.route;
          this.route.environment = data.env;
          this.routeStats = data;
          const countLists = {
            requests: data.total.count,
            notices: data.noticeCount,
            time: data.time,
          };
          this.errorRateList = this.errorRateListService.statsFor(
            countLists,
            this.dur,
            this.lastN,
          );
          this.statusCode = this.findStatusCode(data, this.route.status);

          return this.statusCode;
        }),
      )
      .pipe(
        finalize(() => {
          this.loadingRouteStats = false;
          this.timeDurSwitchEnabled = true;
        }),
      );
  }

  private findStatusCode(routesStats: any, status: any) {
    if (routesStats[status] && routesStats[status].count[0] > 0) {
      return { name: status, ...routesStats[status] };
    }

    if (routesStats.statusCodes[this.route.status]) {
      return { name: status, ...routesStats.statusCodes[status] };
    }

    return { name: "total", value: "", ...routesStats.total };
  }
}
